import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { EditQADialog } from '../EditQADialog.jsx';
import Button from '@mui/material/Button';
/**
 * @param {EditAssuranceRenderer.propTypes} props
 * @return {JSX.Element}
 */

export function EditAssuranceRenderer(props) {
    let { disabled, buttonSx, context, bcpRequest, action, setNewCellValue,apiRef,canAcceptOrReject,
        refreshLine,
        currentColumnName, deleteElementsForColumns } = props;
    const [refreshMe, setRefreshMe] = useState(false);
    const closePopup = () => {
        setRefreshMe(false)
    }
    return (
        <>
            <Button
                variant={'text'}
                disabled={disabled}
                sx={buttonSx}
                onClick={() => {
                    setRefreshMe(true)
                }}
            >
                {action}
            </Button>
            {refreshMe && <EditQADialog
                setRefreshMe={setRefreshMe}
                apiRef={apiRef}
                refreshMe={refreshMe}
                closePopup={() => closePopup()}
                context={context}
                currentColumnName={currentColumnName}
                canAcceptOrReject={canAcceptOrReject}
                bcpRequest={bcpRequest}
                refreshLine={refreshLine}
                setNewCellValue={setNewCellValue}
                deleteElementsForColumns={deleteElementsForColumns}
            />
            }
        </>
    )
}
EditAssuranceRenderer.propTypes = {
    context: PropTypes.object.isRequired,
    bcpRequest: PropTypes.object.isRequired,
    disabled: PropTypes.bool,
    buttonSx: PropTypes.object,
    apiRef: PropTypes.object,
    action: PropTypes.string,
    setNewCellValue: PropTypes.func,
    deleteElementsForColumns: PropTypes.func,


};
